import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const RecommendationSchema = withDefaults({
  type: 'recommendation',
  objectExtensions: ['recommendation'],
  fields: [
    {
      kind: 'attribute',
      name: 'calculationInput',
    },
    {
      kind: 'attribute',
      name: 'calculationOutput',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'requestingApp',
    },
    {
      kind: 'attribute',
      name: 'inputSummary',
    },
    {
      kind: 'attribute',
      name: 'outputSummary',
    },
    {
      kind: 'attribute',
      name: 'currentPlanSummary',
    },
    {
      kind: 'attribute',
      name: 'currentPlanTableHeadings',
    },
    {
      kind: 'attribute',
      name: 'bestPlanSummary',
    },
    {
      kind: 'attribute',
      name: 'bestPlanTableHeadings',
    },
    {
      kind: 'attribute',
      name: 'bestPlanNextSteps',
    },
    {
      kind: 'attribute',
      name: 'directLoansInput',
    },
    {
      kind: 'attribute',
      name: 'ffelLoansInput',
    },
    {
      kind: 'attribute',
      name: 'plusLoansInput',
    },
    {
      kind: 'attribute',
      name: 'directLoansOutput',
    },
    {
      kind: 'attribute',
      name: 'ffelLoansOutput',
    },
    {
      kind: 'attribute',
      name: 'plusLoansOutput',
    },
    {
      kind: 'attribute',
      name: 'hasErrorInCalcs',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default RecommendationSchema;
